import BButton from 'components/common/BButton';
import ShareIcon from 'components/Icons/share.svg';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent, useState } from 'react';
import { useFavorite } from 'hooks/useFavorite';
import { ExperienceSelectAndWishlistEventPayload } from 'types/analytics.type';
import Favourited from 'components/common/Favourited';
import VehicleDetailShareDropdown from 'components/Vehicle/VehicleDetail/VehicleDetailShareDropdown';

interface ExperienceDetailTitleProps {
  experienceName: string;
  harbor: string;
  region: string;
  isFavorited: boolean;
  experienceId: number;
  addToWishlistPayload: ExperienceSelectAndWishlistEventPayload;
}

const ExperienceDetailTitle: FunctionComponent<ExperienceDetailTitleProps> = ({
  experienceName,
  harbor,
  region,
  isFavorited,
  experienceId,
  addToWishlistPayload,
}) => {
  const { t } = useTranslation();
  const [shareDropdown, setShareDropdown] = useState<boolean>(false);
  const { toggleExperienceFavorite, isCurrentFavorited } = useFavorite(
    isFavorited,
    undefined,
    addToWishlistPayload
  );

  return (
    <section className="vehicle-title">
      <div className="flex w-full items-center justify-between">
        <h1 className="text-lg font-medium md:text-xl md:font-semibold">
          {experienceName}
        </h1>

        <div className="flex gap-2">
          <div className="relative">
            <BButton
              priority="text"
              variant="secondary"
              className="flex items-center gap-2"
              onClick={() => setShareDropdown(true)}
            >
              <ShareIcon className="w-5" />
              <span className="hidden md:inline-block">
                {t('vehicle:share')}
              </span>
            </BButton>
            <VehicleDetailShareDropdown
              show={shareDropdown}
              onClose={() => setShareDropdown(false)}
            />
          </div>
          <BButton
            variant="secondary"
            priority="text"
            onClick={() => toggleExperienceFavorite(experienceId)}
          >
            <div className="flex items-center gap-2">
              <Favourited
                isCurrentFavorited={isCurrentFavorited}
                size={20}
                isPrimary
              />
              <span className="hidden md:inline-block">
                {t('vehicle:favorite')}
              </span>
            </div>
          </BButton>
        </div>
      </div>
      <div className="mt-1 flex w-full items-center justify-between">
        <span className="font-medium text-slate-500">{`${harbor}, ${region}`}</span>
      </div>
    </section>
  );
};

export default ExperienceDetailTitle;
